















































































































































import gql from 'graphql-tag'
import { Component, Mixins, Watch } from 'vue-property-decorator'

import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppEmptyCard from '@/components/AppEmptyCard.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import ItemTile from '@/components/ItemTile.vue'
import AppTabBar from '@/components/AppTabBar.vue'
import AppTile from '@/components/AppTile.vue'

import { User } from '@/mixins'

import { CURRENT_USER } from '@/gql/auth'
import { FEED_TILE_FRAGMENT } from '@/gql/feed'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { MY_USER } from '@/gql/user'

@Component({
  components: {
    AppConfirmModal,
    AppEmptyCard,
    AppRouterLink,
    ItemTile,
    AppTabBar,
    AppTile
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    },
    userByUsername: {
      query: gql`query ($username: String) {
        userByUsername(username: $username) {
          id
          username
          displayName
          description
          followerCount
          followedUserCount
          feedLikeCount
          isSubscribed @client
          instagramUrl
          youtubeUrl
          hasActivePepperRegistration
          media {
            id
            path
          }
          backgroundMedia {
            id
            path
          }
          savedFeeds @client {
            id
            thumbnailImagePath
          }
        }
      }`,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    },
    createdFeedConnection: {
      query () {
        return gql`query createdFeedConnectionAtViewProfile($userId: Int, $after: String) {
          createdFeedConnection(userId: $userId, after: $after) {
            cursor
            hasNextPage
            feeds {
              ...FeedTileFragment
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'USER_CREATED_FEED' || !this.currentUser
      }
    },
    likedItemConnection: {
      query () {
        return gql`query ($userId: ID, $after: String, $strict: Boolean) {
          likedItemConnection(userId: $userId, after: $after, strict: $strict) {
            cursor
            hasNextPage
            items {
              ...ItemTileFragment
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'LIKED_ITEM' || !localStorage.getItem('identityProvider')
      }
    }
  }
})
export default class extends Mixins(User) {
  currentUser: { id: string; username: string } | null = null
  myUser = {}
  fetchMoreInProgress = false
  isSubmittedModalActive = false
  isFeedLikeCountModalActive = false

  get currentTab () {
    if (typeof this.$route.query.tab === 'string' && this.$route.query.tab) return this.$route.query.tab
    return 'USER_CREATED_FEED'
  }

  userByUsername: {
    id: string;
    displayName: string;
    username: string;
    description: string;
    followerCount: number;
    followedUserCount: number;
    feedLikeCount: number;
    isSubscribed: boolean;
    savedFeeds: { }[];
    hasActivePepperRegistration: boolean;
    backgroundMedia?: {
      id: string;
      path: string;
    };
  } = {
    id: '',
    displayName: '',
    username: '',
    description: '',
    isSubscribed: false,
    followerCount: 0,
    followedUserCount: 0,
    feedLikeCount: 0,
    savedFeeds: [],
    hasActivePepperRegistration: false
  }

  createdFeedConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    feeds: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    feeds: []
  }

  likedItemConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    items: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    items: []
  }

  queryFuncs: {
    [key: string]: {
      queryName: string;
      updateQuery: (prevResult: any, fetchMoreResult: any) => any;
    };
  } = {
    USER_CREATED_FEED: {
      queryName: 'createdFeedConnection',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          ...fetchMoreResult,
          createdFeedConnection: {
            ...fetchMoreResult.createdFeedConnection,
            feeds: [
              ...previousResult.createdFeedConnection.feeds,
              ...fetchMoreResult.createdFeedConnection.feeds
            ]
          }
        }
      }
    },
    LIKED_ITEM: {
      queryName: 'likedItemConnection',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          ...fetchMoreResult,
          likedItemConnection: {
            ...fetchMoreResult.likedItemConnection,
            items: [
              ...previousResult.likedItemConnection.items,
              ...fetchMoreResult.likedItemConnection.items
            ]
          }
        }
      }
    }
  }

  get connection () {
    switch (this.currentTab) {
      case 'USER_CREATED_FEED': return this.createdFeedConnection
      case 'LIKED_ITEM': return this.likedItemConnection
    }
    return { hasNextPage: false, cursor: '' }
  }

  get variables (): object {
    switch (this.currentTab) {
      case 'USER_CREATED_FEED': return { userId: this.currentUser && +this.currentUser.id }
      case 'LIKED_ITEM': return { strict: true }
    }
    return {}
  }

  @Watch('$route')
  async onRouteChanged (to: { query: { tab: string } }) {
    if (to.query.tab) {
      await this.$nextTick()
      this.scrollIntoView()
    }
  }

  scrollIntoView () {
    const ele = document.getElementById('view-profile__tab-bar')
    if (ele) {
      ele.scrollIntoView()
    }
  }

  get availableTabs () {
    return [
      { id: 'USER_CREATED_FEED', name: '스토리' },
      { id: 'LIKED_ITEM', name: '아이템' }
    ]
  }

  get currentFeeds () {
    return this.currentTab === 'USER_CREATED_FEED' ? this.createdFeedConnection.feeds : []
  }

  get showFeedGrid () {
    return this.currentFeeds.length > 0
  }

  get currentItems () {
    return this.currentTab === 'LIKED_ITEM' ? this.likedItemConnection.items : []
  }

  get showItemGrid () {
    return this.currentItems.length > 0
  }

  mounted () {
    window.onscroll = () => {
      if (!this.currentTab) return

      if (
        !this.connection.hasNextPage ||
        this.fetchMoreInProgress ||
        document.documentElement.scrollTop + window.innerHeight + 1000 < document.documentElement.offsetHeight
      ) return
      this.fetchMoreInProgress = true
      this.$apollo.queries[this.queryFuncs[this.currentTab].queryName].fetchMore({
        variables: {
          ...this.variables,
          after: this.connection.cursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.fetchMoreInProgress = false
          return this.queryFuncs[this.currentTab].updateQuery(previousResult, fetchMoreResult)
        }
      }).catch(e => e.name !== 'Invariant Violation' && console.error(e))
    }
  }

  async showLoginModal () {
    await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
  }

  onClickCreatorApply () {
    if (this.userByUsername.hasActivePepperRegistration) {
      this.isSubmittedModalActive = true
    } else {
      this.routerPush('/creator/apply')
    }
  }
}
